/* tslint:disable */
/* eslint-disable */
/**
 * PRMGApp
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { CarFromJSON, CarToJSON, } from './';
export function CarFilePhotoRelationFromJSON(json) {
    return CarFilePhotoRelationFromJSONTyped(json, false);
}
export function CarFilePhotoRelationFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'car': !exists(json, 'car') ? undefined : CarFromJSON(json['car']),
        'carId': !exists(json, 'carId') ? undefined : json['carId'],
        'file': !exists(json, 'file') ? undefined : json['file'],
        'fileId': !exists(json, 'fileId') ? undefined : json['fileId'],
        'order': json['order'],
    };
}
export function CarFilePhotoRelationToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'car': CarToJSON(value.car),
        'carId': value.carId,
        'file': value.file,
        'fileId': value.fileId,
        'order': value.order,
    };
}
